<app-action-icon #iconCmp
  [value]="isFavorite"
  [state]="state"
  (toggle)="toggleFavorite($event)"
  class="airport-favorite-icon__container"
  [class.airport-favorite-icon__container--active]="isFavorite"
  [class.airport-favorite-icon__container--hover]="iconCmp.hover">
  <mat-icon
    [matTooltip]="tooltip"
    class="airport-favorite-icon__icon"
    [class.airport-favorite-icon__icon--active]="isFavorite"
    [class.airport-favorite-icon__icon--hover]="iconCmp.hover">
    {{icon}}
  </mat-icon>
</app-action-icon>
